import { middletownNJConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function MiddletownNJPage() {
  return <CityPageTemplate config={middletownNJConfig} />;
}